import { render } from "./FocusFigure.vue?vue&type=template&id=6500e1d9"
import script from "./FocusFigure.vue?vue&type=script&lang=js"
export * from "./FocusFigure.vue?vue&type=script&lang=js"

import "./FocusFigure.vue?vue&type=style&index=0&id=6500e1d9&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__